export const SHOPIFY_IMAGE_PIXEL_LIMIT = 20_000_000;

// Shopify Files rejects images at 20MP. Leave one megapixel of headroom for
// encoder rounding while retaining substantially more detail than a side cap.
export const SHOPIFY_ASSET_PIXEL_BUDGET = 19_000_000;
export const PREVIEW_IMAGE_PIXEL_BUDGET = SHOPIFY_ASSET_PIXEL_BUDGET;
export const SAVED_DESIGN_PREVIEW_MAX_AXIS = 1_800;
export const CUTOUT_PREVIEW_MAX_AXIS = 1_800;
export const DESIGN_PREVIEW_MAX_AXIS = SAVED_DESIGN_PREVIEW_MAX_AXIS;

export interface PreviewImageSizingOptions {
  pixelBudget?: number;
  maxAxis?: number;
}

export function calculatePreviewPixelRatio(
  width: number,
  height: number,
  {
    pixelBudget = PREVIEW_IMAGE_PIXEL_BUDGET,
    maxAxis = SAVED_DESIGN_PREVIEW_MAX_AXIS,
  }: PreviewImageSizingOptions = {},
): number {
  if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) {
    return 1;
  }

  const pixelBudgetRatio = Math.sqrt(pixelBudget / (width * height));
  const axisRatio = maxAxis / Math.max(width, height);
  return Math.min(1, pixelBudgetRatio, axisRatio);
}

export function getPreviewPixelDimensions(
  width: number,
  height: number,
  options: PreviewImageSizingOptions = {},
) {
  const pixelRatio = calculatePreviewPixelRatio(width, height, options);
  const outputWidth = Math.max(1, Math.floor(width * pixelRatio));
  const outputHeight = Math.max(1, Math.floor(height * pixelRatio));

  return {
    width: outputWidth,
    height: outputHeight,
    pixels: outputWidth * outputHeight,
    pixelRatio,
  };
}
